/**
 * 获取码表数据源
 * */
let getSimpleCodeListByCodeTypeCodes = (codeTypeCodes,callback) => {
    if (window.vm.$zwxBase.verifyIsNotBlank(codeTypeCodes)) {
        let param = {
            codeTypeCodes: codeTypeCodes
        }
        window.vm.$system.get(window.vm.$store.state.api + '/systematic/getSimpleCodeListByCodeTypeCodesMap-0', param, false, false, data => {
            callback(data.resultMap)
        }, () => {})
    }
}

let manyListFul = (data, pid) => {
    //递归方法 生成 json tree 数据
    var result = [],
        temp,
        obj
    data.some(e => {
        let LevelNoArr = e.codeLevelNo.split('.')
        if ((e.codeLevelNo == e.codeNo && pid == '') || LevelNoArr[LevelNoArr.length - 2] == pid) {
            obj = { ...e }
            temp = manyListFul(data, e.codeNo)
            if (temp.length > 0) {
                obj.children = temp
            }
            result.push(obj)
        }
    })
    return result
}

/**
 * 获取地区数据源
 * */
let getAreaList = (zoneCode12, zoneTypeMax, zoneTypeMin, callback) => {
    if (window.vm.$zwxBase.verifyIsNotBlank(zoneCode12)) {
        let param = {
            zoneCode12From: zoneCode12,
            zoneTypeMax: zoneTypeMax,
            zoneTypeMin: zoneTypeMin
        }
        window.vm.$system.get(window.vm.$store.state.api + '/systematic/getTypeAllAreaList-0', param, false, false, data => {
            callback(data.areaList)
        }, () => {})
    }
}

/**
 *
 */
let baseGetAreaSelect = (areaList, field) => {
    areaList = areaList === null ? [] : areaList;
    var area = {};
    area.resultAreaList = [];
    area.zoneType = -1;
    var levelAreaList = [];
    for (var level = 0, areaLength = areaList.length; level < areaLength; level++) {
        if (typeof (levelAreaList[areaList[level].zoneType]) === 'undefined') {
            levelAreaList[areaList[level].zoneType] = [];
        }
        levelAreaList[areaList[level].zoneType].push(areaList[level]);
    }
    for (var index = 0, levelLength = levelAreaList.length; index < levelLength; index++) {
        if (typeof levelAreaList[index] === 'undefined') {
            levelAreaList[index] = [];
        }
        if (levelAreaList[index].length > 0) {
            area.zoneType = levelAreaList[index][0].zoneType;
            break;
        }
    }
    if (area.zoneType > -1) {
        baseInitArea(field, area.resultAreaList, levelAreaList, area.zoneType, area.zoneType, null);
    }
    return area;
}
/**
 * baseGetAreaSelect递归使用
 * */
let baseInitArea = (field, resultAreaList, levelAreaList, zoneType, levelIndex, lastArea) => {
    for (var i = 0, length = levelAreaList[levelIndex].length; i < length; i++) {
        if (levelIndex === zoneType
            || levelIndex === 0
            || levelIndex === 1
            || levelIndex === 2 && lastArea.info.zoneCode12.substring(0, 2) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 2)
            || levelIndex === 3 && levelAreaList[levelIndex][i].zoneCode12.substring(4, 6) !== '00' && lastArea.info.zoneCode12.substring(0, 4) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 4)
            || levelIndex === 3 && levelAreaList[levelIndex][i].zoneCode12.substring(4, 6) === '00' && lastArea.info.zoneCode12.substring(0, 6) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 6)
            || levelIndex === 4 && levelAreaList[levelIndex][i].zoneCode12.substring(4, 6) !== '00' && lastArea.info.zoneCode12.substring(0, 6) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 6)
            || levelIndex === 4 && levelAreaList[levelIndex][i].zoneCode12.substring(4, 6) === '00' && lastArea.info.zoneCode12.substring(0, 9) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 9)
            || levelIndex === 5 && lastArea.info.zoneCode12.substring(0, 9) === levelAreaList[levelIndex][i].zoneCode12.substring(0, 9)) {
            var area = {};
            if (field === 'rid') {
                area.value = levelAreaList[levelIndex][i].rid;
            } else if (field === 'zoneCode12') {
                area.value = levelAreaList[levelIndex][i].zoneCode12;
            }
            if (lastArea) {
                area.codeLevelNo = lastArea.codeLevelNo + '.'+area.value;
            } else {
                area.codeLevelNo = levelAreaList[levelIndex][i].zoneCode12;
            }
            area.info = levelAreaList[levelIndex][i];
            area.label = levelAreaList[levelIndex][i].zoneName;
            if (levelIndex + 1 < levelAreaList.length) {
                baseInitArea(field, resultAreaList, levelAreaList, zoneType, levelIndex + 1, area);
            }
            if (levelIndex > zoneType) {
                if (typeof (lastArea.children) === 'undefined') {
                    lastArea.children = [];
                }
                lastArea.children.push(area);
            } else {
                resultAreaList.push(area);
            }
            levelAreaList[levelIndex].splice(i, 1);
            i--;
            length--;
        }
    }
}

export default { getSimpleCodeListByCodeTypeCodes, manyListFul, getAreaList, baseGetAreaSelect}
